import { render } from "./Design.vue?vue&type=template&id=8b64ddf4&ts=true"
import script from "./Design.vue?vue&type=script&lang=ts"
export * from "./Design.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__